export default __webpack_public_path__ + "images/6fc4e56bb019b9a78b6778be7960728b-food_and_drink_mobile.webp";